import React from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";

export default function SalesOrder(props) {
  const navigate = PagesIndex.useNavigate();
  const { salesOrderListData } = props;
  return (
    <Index.Box>
      <Index.Box className="dash-slider-row">
        <Index.Box className="admin-user-list-flex admin-page-title-main">
          <Index.Typography
            className="admin-page-title admin-user-list-page-title"
            component="h2"
            variant="h2"
          ></Index.Typography>
        </Index.Box>
        <Index.Box className="page-table-main common-card">
          <Index.TableContainer
            component={Index.Paper}
            className="table-container"
          >
            <Index.Table aria-label="simple table" className="table">
              <Index.TableHead className="table-head">
                <Index.TableRow className="table-row">
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    width="10%"
                  >
                    Order Id
                  </Index.TableCell>

                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    width="15%"
                  >
                    Client Name
                  </Index.TableCell>

                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    width="15%"
                  >
                    Deal Name
                  </Index.TableCell>

                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    width="12%"
                  >
                    Total Amount
                  </Index.TableCell>
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    width="22%"
                  >
                    Created Date & Time
                  </Index.TableCell>

                  {/* <Index.TableCell
                            component="th"
                            variant="th"
                            className="table-th"
                            width="12%"
                          >
                            Status
                          </Index.TableCell> */}

                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    width="5%"
                    align="right"
                  >
                    Action
                  </Index.TableCell>
                </Index.TableRow>
              </Index.TableHead>
              <Index.TableBody className="table-body">
                {salesOrderListData?.length ? (
                  salesOrderListData?.map((data) => {
                    return (
                      <Index.TableRow
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                        key={data?._id}
                      >
                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          <Index.Typography className="admin-table-data-text">
                            <span className="news-id-text">
                              {data?.orderNo}
                            </span>
                          </Index.Typography>
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          scope="row"
                          className="table-td"
                        >
                          <Index.Typography className="admin-table-data-text news-id-text">
                            {data?.client?.compName || "-"}
                          </Index.Typography>

                          <Index.Typography className="admin-table-data-text">
                            {data?.client?.firstName || "-"}
                          </Index.Typography>
                        </Index.TableCell>

                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          <Index.Typography className="admin-table-data-text">
                            {data?.campaignName}
                          </Index.Typography>
                        </Index.TableCell>

                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          <Index.Typography className="admin-table-data-text">
                            {parseFloat(data?.totalAmount)?.toLocaleString(
                              "en-Us"
                            ) || "-"}
                          </Index.Typography>
                        </Index.TableCell>

                        <Index.TableCell
                          component="td"
                          variant="td"
                          className="table-td"
                        >
                          <Index.Typography className="admin-table-data-text">
                            {data?.updatedAt || data?.createdBy?.name
                              ? data?.createdBy?.name +
                                "-" +
                                PagesIndex.moment(
                                  new Date(data?.updatedAt)
                                ).format("DD/MM/YYYY hh:mm A")
                              : "-"}
                          </Index.Typography>
                        </Index.TableCell>
                        <Index.TableCell
                          component="td"
                          variant="td"
                          align="right"
                          className="table-td"
                        >
                          <Index.Box className="admin-table-data-btn-flex ">
                            <Index.Tooltip
                              title="View"
                              arrow
                              placement="bottom"
                              className="admin-tooltip"
                            >
                              <Index.Button
                                className="admin-table-data-btn"
                                onClick={() =>
                                  navigate(
                                    `/admin/view-sales-order/${data?._id}`
                                  )
                                }
                              >
                                <img
                                  src={PagesIndex.Svg.yelloweye}
                                  className="admin-icon"
                                  alt="View"
                                />
                              </Index.Button>
                            </Index.Tooltip>

                            <Index.Tooltip
                              title="View Bookings"
                              arrow
                              placement="bottom"
                              className="admin-tooltip"
                            >
                              <Index.Button
                                className="admin-table-data-btn"
                                onClick={() => {
                                  navigate(
                                    `/admin/sales-sub-order-list/${data?._id}`
                                  );
                                }}
                              >
                                <img
                                  src={PagesIndex.Svg.viewbookingIcon}
                                  className="admin-icon"
                                  alt="View Booking"
                                />
                              </Index.Button>
                            </Index.Tooltip>
                          </Index.Box>
                        </Index.TableCell>
                      </Index.TableRow>
                    );
                  })
                ) : (
                  <PagesIndex.DataNotFound />
                )}
              </Index.TableBody>
            </Index.Table>
          </Index.TableContainer>
        </Index.Box>
      </Index.Box>
    </Index.Box>
  );
}
